import { Link } from 'react-router-dom'

/** Rendered instead of an admin-only page when the signed-in user is not an
 *  admin — reached by hitting the URL directly, not only by clicking a nav
 *  item (which editors never see in the first place). Never a blank page or
 *  a raw error. */
export function NotPermitted() {
  return (
    <div className="flex h-full items-center justify-center p-6">
      <div
        role="alert"
        className="max-w-sm rounded-lg border border-ink-200 bg-white p-5 text-center shadow-sm"
      >
        <p className="text-2xl" aria-hidden="true">
          ⚿
        </p>
        <h1 className="mt-2 text-sm font-semibold text-ink-900">Not permitted</h1>
        <p className="mt-1 text-xs text-ink-600">
          This page is restricted to admins. Ask an admin if you need access.
        </p>
        <Link to="/" className="btn btn-primary mt-4 justify-center">
          Back to dashboard
        </Link>
      </div>
    </div>
  )
}
